import { render, staticRenderFns } from "./AudioContent.vue?vue&type=template&id=40e7a17a&scoped=true&"
import script from "./AudioContent.vue?vue&type=script&lang=js&"
export * from "./AudioContent.vue?vue&type=script&lang=js&"
import style0 from "./AudioContent.vue?vue&type=style&index=0&id=40e7a17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e7a17a",
  null
  
)

export default component.exports